import Vue from 'vue';
import App from '../App.vue';

import VueRouter from 'vue-router';
import Login from '../components/Login.vue'

Vue.use(VueRouter);

export const router = new VueRouter({
    routes : [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                guest: true
            }
            
        },
        {
            path : '/:instanceName',
            name : 'home',
            component : App,
            meta:{
                requiresAuth: true
            }
            
        } 
    ],
    mode: 'history'
})

router.beforeEach((to,from,next)=>{ 

    if(to.matched.some(record => record.meta.requiresAuth)){
        
        if(localStorage.getItem('auth') == null){
            router.push({
                path: '/login',
                query: { nextUrl: to.fullPath }
            })
        }else{
            next()
        }
    }else{
        next()
    }
})
